/* Il Botteghino - cassetti e carrello (Cart API di Shopify). Nessuna libreria, window.BT, niente lavoro all'avvio oltre ai listener.
   Scheda, ricerca e consenso stanno in bt-product.js, bt-search.js, bt-consent.js. */
(function () {
  "use strict";
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var noop = function () {};
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  var BT = window.BT = window.BT || {};

  /* prezzi: stesso formato di bt-money, secondo la lingua della pagina (it/de 1.250,00 €, en €1,250.00) */
  var fmt = null, fmtLang = "";
  BT.money = function (cents) {
    var c = Math.round(Number(cents) || 0), neg = c < 0, lang = (document.documentElement.lang || "it").slice(0, 2).toLowerCase(), out;
    if (neg) c = -c;
    try {
      if (!fmt || fmtLang !== lang) { fmtLang = lang; fmt = new Intl.NumberFormat(lang === "en" ? "en-US" : lang === "de" ? "de-DE" : "it-IT", { style: "currency", currency: "EUR", useGrouping: "always" }); }
      out = fmt.format(c / 100);
    } catch (e) {
      var w = String(Math.floor(c / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, lang === "en" ? "," : "."), d = c % 100;
      out = lang === "en" ? "€" + w + "." + (d < 10 ? "0" : "") + d : w + "," + (d < 10 ? "0" : "") + d + " €";
    }
    return (neg ? "-" : "") + out;
  };

  /* cassetti: menu, carrello, ricerca, ingrandimento */
  function openDialog(d) {
    if (!d || d.open || typeof d.showModal !== "function") return;
    d.showModal();
    var f = $("[data-autofocus]", d);
    if (f) f.focus();
  }
  document.addEventListener("click", function (e) {
    var open = e.target.closest("[data-open]");
    if (open) {
      var d = document.getElementById(open.getAttribute("data-open"));
      /* su /cart il pulsante del carrello resta un link */
      if (!d || typeof d.showModal !== "function" || (d.id === "carrello" && $("[data-cart-page]"))) return;
      e.preventDefault();
      openDialog(d);
      return;
    }
    var close = e.target.closest("[data-close]");
    if (close) { var dlg = close.closest("dialog"); if (dlg) dlg.close(); return; }
    if (e.target.tagName === "DIALOG" && e.target.open) e.target.close();
  });

  if (!window.fetch || !window.Promise || !window.DOMParser) return; /* senza: i link portano a /cart */

  var chain = Promise.resolve();
  function enqueue(fn) { var p = chain.then(fn); chain = p.then(noop, noop); return p; } /* una richiesta alla volta, in ordine */
  var fire = function (name, detail) { document.dispatchEvent(new CustomEvent(name, { detail: detail })); };
  var drawer = function () { return document.getElementById("carrello"); };

  function api(url, body) {
    var o = { credentials: "same-origin", headers: { Accept: "application/json" } };
    if (body) { o.method = "POST"; o.headers["Content-Type"] = "application/json"; o.body = JSON.stringify(body); }
    return fetch(url, o).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) {
        if (!res.ok) {
          var err = new Error(data.description || data.message || "");
          err.status = res.status; err.data = data;
          throw err;
        }
        return data;
      });
    });
  }

  function sectionIds() {
    var ids = [], d = drawer(), p = $("[data-cart-page]");
    if (d) ids.push(d.getAttribute("data-section-id") || "cart-drawer");
    if (p && p.getAttribute("data-section-id")) ids.push(p.getAttribute("data-section-id"));
    return ids;
  }

  function readState(root) {
    var s = root && $("[data-cart-json]", root);
    try { return s ? JSON.parse(s.textContent) : null; } catch (e) { return null; }
  }
  function strings() { var s = readState(drawer()); return (s && s.strings) || {}; }

  /* focus e scroll sopravvivono al ridisegno */
  function memo(root) {
    var a = document.activeElement;
    if (!a || !root.contains(a)) return null;
    var row = a.closest("[data-line]"), q = a.closest("[data-qty]"), add = a.closest("[data-add]");
    return { line: row && row.getAttribute("data-line"), qty: q && q.getAttribute("data-qty"), rm: !!a.closest("[data-remove]"), add: add && add.getAttribute("data-id"), close: !!a.closest("[data-close]"), note: a.matches("textarea") };
  }
  function usable(el) { return el && !el.disabled && el.getAttribute("aria-disabled") !== "true"; }
  function restore(root, m) {
    if (!m) return;
    var t = null, row = null;
    if (m.line) {
      row = $$("[data-line]", root).filter(function (r) { return r.getAttribute("data-line") === m.line; })[0];
      if (row) {
        t = m.rm ? $("[data-remove]", row) : (m.qty ? $('[data-qty="' + m.qty + '"]', row) : null);
        if (!usable(t)) t = $$("[data-qty]", row).filter(usable)[0] || $("[data-remove]", row);
      }
    } else if (m.add) {
      t = $$("[data-add]", root).filter(function (b) { return b.getAttribute("data-id") === m.add; })[0];
    }
    if (m.note) t = $("textarea", root);
    if (!usable(t)) t = (m.close && $("[data-close]", root)) || $("[data-autofocus]", root) || $("[data-focus-fallback]", root);
    if (t) t.focus({ preventScroll: true });
  }
  function swap(oldEl, newEl) {
    var m = memo(oldEl), list = $(".bt-cart__items", oldEl), top = list ? list.scrollTop : 0, fresh = document.importNode(newEl, true);
    var n1 = $("textarea[name=note]", oldEl), n2 = $("textarea[name=note]", fresh); /* la nota digitata non va persa */
    if (n1 && n2 && n1.value !== n2.value) { n2.value = n1.value; n2.closest("details").open = true; }
    oldEl.replaceWith(fresh);
    var l2 = $(".bt-cart__items", fresh);
    if (l2) l2.scrollTop = top;
    restore(fresh, m);
    return fresh;
  }

  /* ridisegna cassetto e pagina con l'HTML delle sezioni; restituisce lo stato (JSON nel cassetto) */
  function applySections(sections) {
    var state = null, dlg = drawer(), page = $("[data-cart-page]"), html, doc, nw, old;
    if (dlg && (html = sections[dlg.getAttribute("data-section-id") || "cart-drawer"])) {
      doc = new DOMParser().parseFromString(html, "text/html");
      nw = $(".bt-cart", doc); old = $(".bt-cart", dlg);
      if (nw && old) state = readState(swap(old, nw));
    }
    if (page && (html = sections[page.getAttribute("data-section-id")])) {
      doc = new DOMParser().parseFromString(html, "text/html");
      nw = $("[data-cart-page]", doc);
      if (nw) swap(page, nw);
    }
    return state;
  }

  function setCount(st) {
    $$("[data-cart-count]").forEach(function (b) { b.textContent = st.item_count; b.setAttribute("data-n", st.item_count); });
    if (st.link_label) $$("[data-cart-link]").forEach(function (a) { a.setAttribute("aria-label", st.link_label); });
    var live = $("[data-cart-status]");
    if (live && st.status) live.textContent = st.status;
  }
  function finish(st) { setCount(st); fire("bt:cart:updated", st); return st; }

  function refreshNow() {
    var ids = sectionIds();
    if (!ids.length) return api(ROOT + "cart.js").then(finish);
    return api(location.pathname + "?sections=" + encodeURIComponent(ids.join(","))).then(function (sections) {
      return applySections(sections) || api(ROOT + "cart.js");
    }).then(finish);
  }
  function commit(data) {
    var st = data && data.sections ? applySections(data.sections) : null;
    return st ? finish(st) : refreshNow(); /* sezione non arrivata: la richiedo, poi ripiego su /cart.js */
  }

  /* errori: <p class="bt-cart__msg" role="alert"> nel cassetto e nella pagina */
  function showMsg(text) {
    var seen = false, al = $("[data-cart-alert]");
    $$(".bt-cart__msg").forEach(function (p) {
      p.textContent = text; p.hidden = !text;
      if (text && p.offsetParent) { seen = true; if (p.scrollIntoView) p.scrollIntoView({ block: "nearest" }); }
    });
    /* cassetto chiuso: il messaggio nel dialog non si legge, lo annuncia l'area fuori dai dialog */
    if (al) al.textContent = text && !seen ? text : "";
  }
  function fail(err) {
    var s = strings(), msg = err && err.status ? (err.message || s.generic) : (err instanceof TypeError ? s.network : s.generic);
    showMsg(msg || "");
    fire("bt:cart:error", { message: msg || "", status: (err && err.status) || 0, data: (err && err.data) || null });
  }
  function busy(on) {
    $$(".bt-cart, [data-cart-page]").forEach(function (el) { if (on) el.setAttribute("aria-busy", "true"); else el.removeAttribute("aria-busy"); });
  }

  function run(path, body, check) {
    showMsg(""); busy(true);
    var ids = sectionIds();
    if (ids.length) { body.sections = ids.join(","); body.sections_url = location.pathname; }
    return api(ROOT + path, body).then(commit).then(function (st) {
      if (check && st && !check(st)) { var m = strings().qty || ""; showMsg(m); fire("bt:cart:error", { message: m, status: 0, data: null }); }
      return st;
    }).catch(function (err) {
      if (err && err.status === 422) { /* il negozio ha meno pezzi di quelli chiesti: riallineo carrello e contatore prima di dire l'errore */
        return refreshNow().catch(function () { return null; }).then(function () { fail(err); throw err; });
      }
      fail(err); throw err;
    }).finally(function () { busy(false); });
  }

  function lineQty(key) {
    var r = $$("[data-line]").filter(function (el) { return el.getAttribute("data-line") === key; })[0];
    return r ? parseInt(r.getAttribute("data-quantity"), 10) || 0 : null;
  }
  function checkQty(key, want) { /* la quantità chiesta è arrivata? se no, il negozio ha meno pezzi */
    return function (st) {
      var l = (st.items || []).filter(function (i) { return i.key === key; })[0];
      return want < 1 || (l && l.quantity >= want);
    };
  }
  function norm(it) {
    var id = Number(it && it.id), q = parseInt(it && it.quantity, 10), o;
    if (!id) return null;
    o = { id: id, quantity: q > 0 ? q : 1 };
    if (it.properties && Object.keys(it.properties).length) o.properties = it.properties;
    return o;
  }

  BT.cart = {
    add: function (items) {
      items = (Array.isArray(items) ? items : [items]).map(norm).filter(Boolean);
      if (!items.length) return Promise.reject(new Error("articolo mancante"));
      return enqueue(function () { return run("cart/add.js", { items: items }); });
    },
    change: function (key, qty) { /* key = chiave della riga (stringa), mai l'id numerico */
      key = String(key); qty = Math.max(0, parseInt(qty, 10) || 0);
      return enqueue(function () { return run("cart/change.js", { id: key, quantity: qty }, checkQty(key, qty)); });
    },
    refresh: function () { return enqueue(refreshNow); },
    open: function () { /* già aperto: se il focus si è perso lo riporta sul titolo/chiudi */
      var d = drawer(), f = d && $("[data-autofocus]", d);
      if (!d || $("[data-cart-page]")) return;
      if (!d.open) openDialog(d);
      else if (f && !d.contains(document.activeElement)) f.focus();
    }
  };

  /* delta sulla quantità letta al proprio turno: due clic rapidi non si incrociano */
  function bump(key, delta) {
    return enqueue(function () {
      var cur = lineQty(key), next;
      if (cur === null) return null;
      next = delta === null ? 0 : Math.max(0, cur + delta);
      return run("cart/change.js", { id: key, quantity: next }, checkQty(key, next));
    }).catch(noop);
  }

  function mark(el, on) {
    if (!el) return;
    if (on) el.setAttribute("aria-busy", "true"); else el.removeAttribute("aria-busy");
    if (el.tagName === "BUTTON") el.disabled = on;
  }
  /* il cassetto si apre anche se l'aggiunta fallisce: il messaggio è lì */
  function addFromUI(items, btn) {
    mark(btn, true);
    return BT.cart.add(items).then(BT.cart.open, BT.cart.open).then(function () { mark(btn, false); });
  }

  document.addEventListener("click", function (e) {
    var b = e.target.closest("[data-add]"), c, q, rm, row;
    if (b) { /* il pulsante della scheda ha il suo gestore (bt-product.js) e passa da bt:add */
      if (b.hasAttribute("data-needs") || b.closest("[data-product-form]")) return;
      e.preventDefault();
      if (b.getAttribute("aria-busy") === "true") return;
      addFromUI([{ id: b.getAttribute("data-id"), quantity: b.getAttribute("data-qty") }], b);
      return;
    }
    c = e.target.closest(".bt-card .bt-chip[data-variant-id]"); /* taglia scelta sulla card: aggiunge subito */
    if (c) {
      e.preventDefault();
      if (c.getAttribute("aria-disabled") === "true" || c.getAttribute("aria-busy") === "true") return;
      addFromUI([{ id: c.getAttribute("data-variant-id"), quantity: 1 }], c);
      return;
    }
    q = e.target.closest(".bt-qty [data-qty]"); rm = e.target.closest("[data-remove]");
    row = (q || rm) && (q || rm).closest("[data-line]");
    if (!row || !row.closest("#carrello, [data-cart-page]")) return;
    if (e.button || e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault();
    if (q && !usable(q)) return;
    bump(row.getAttribute("data-line"), rm ? null : parseInt(q.getAttribute("data-qty"), 10));
  });

  /* evento dalla scheda: { id, quantity, properties } */
  document.addEventListener("bt:add", function (e) {
    var d = e.detail || {};
    addFromUI([{ id: d.id, quantity: d.quantity, properties: d.properties }], null).catch(noop);
  });

  /* tornando indietro dalla cache il carrello può essere cambiato */
  window.addEventListener("pageshow", function (e) { if (e.persisted) BT.cart.refresh().catch(noop); });
})();
